import React from "react";

export const CollapsableContext = React.createContext();